import "core-js/modules/es.array.concat.js";
import { service } from './service'; // 查询列表数据

export function LoadData(data) {
  return service({
    url: 'DnbarcodeHandmade/LoadData',
    data: data,
    method: 'post'
  });
} // 查询ERP采购订单明细数据

export function GetErpPartDataList(params) {
  return service({
    url: 'ScmErpPo/GetErpPartDataList',
    method: 'get',
    params: params
  });
} // 保存数据

export function SaveData(data) {
  return service({
    url: 'DnbarcodeHandmade/SaveData',
    method: 'post',
    data: data
  });
} // 获取条码单明细List

export function GetDnbarcodeDtlList(params) {
  return service({
    url: 'DnbarcodeHandmade/GetDnbarcodeDtlList',
    method: 'get',
    params: params
  });
} // 生成手工打码内箱条码

export function CreatePartBarcodeData(data) {
  return service({
    url: 'DnbarcodeHandmade/CreatePartBarcodeData',
    method: 'post',
    data: data
  });
} // 生成手工打码外箱条码

export function CreateOutBoxBarcodeData(data) {
  return service({
    url: 'DnbarcodeHandmade/CreateOutBoxBarcodeData',
    method: 'post',
    data: data
  });
} // 获取手工打码内箱条码List

export function GetPartBarcodeDetailList(params) {
  return service({
    url: 'DnbarcodeHandmade/GetPartBarcodeDetailList',
    method: 'get',
    params: params
  });
} // 获取手工打码内箱条码List--带分页

export function GetPartBarcodeDetailPageList(params) {
  return service({
    url: 'DnbarcodeHandmade/GetPartBarcodeDetailPageList',
    method: 'get',
    params: params
  });
} // 获取手工打码外箱条码List

export function GetDnbarcodePartBoxDtlList(params) {
  return service({
    url: 'DnbarcodeHandmade/GetDnbarcodePartBoxDtlList',
    method: 'get',
    params: params
  });
} // 删除

export function DeleteOneById(ID) {
  return service({
    url: 'DnbarcodeHandmade/DeleteOneById?id=' + ID,
    method: 'post'
  });
} // 导出数据

export function ExportListData(_ref) {
  var ORGANIZE_ID = _ref.ORGANIZE_ID,
      Page = _ref.Page,
      Limit = _ref.Limit,
      LIST_ROUTE = _ref.LIST_ROUTE,
      EXPORT_FILE_NAME = _ref.EXPORT_FILE_NAME;
  return service({
    url: "DnbarcodeHandmade/ExportListData?Data.BILL_TYPE=2&Data.ORGANIZE_ID=".concat(ORGANIZE_ID, "&Page=").concat(Page, "&Limit=").concat(Limit, "&LIST_ROUTE=").concat(LIST_ROUTE, "&Data.EXPORT_FILE_NAME=").concat(EXPORT_FILE_NAME),
    method: 'get'
  });
} // 导出条码明细数据

export function ExportPartBarcodeData(_ref2) {
  var ORGANIZE_ID = _ref2.ORGANIZE_ID,
      MST_ID = _ref2.MST_ID,
      EXPORT_FILE_NAME = _ref2.EXPORT_FILE_NAME;
  return service({
    url: "DnbarcodeHandmade/ExportPartBarcodeData?BARCODE_TYPE=1&ORGANIZE_ID=".concat(ORGANIZE_ID, "&Page=1&Limit=999&MST_ID=").concat(MST_ID, "&EXPORT_FILE_NAME=").concat(EXPORT_FILE_NAME),
    method: 'get'
  });
} // 导出条码明细数据--外箱

export function ExportBoxCodeData(_ref3) {
  var ORGANIZE_ID = _ref3.ORGANIZE_ID,
      MST_ID = _ref3.MST_ID,
      EXPORT_FILE_NAME = _ref3.EXPORT_FILE_NAME;
  return service({
    url: "DnbarcodeHandmade/ExportBoxCodeData?BARCODE_TYPE=1&ORGANIZE_ID=".concat(ORGANIZE_ID, "&Page=1&Limit=999&MST_ID=").concat(MST_ID, "&EXPORT_FILE_NAME=").concat(EXPORT_FILE_NAME),
    method: 'get'
  });
} // 下一张

export function GetLastById(params) {
  return service({
    url: 'DnbarcodeHandmade/GetLastById',
    method: 'get',
    params: params
  });
} // 上一张

export function GetNextById(params) {
  return service({
    url: 'DnbarcodeHandmade/GetNextById',
    method: 'get',
    params: params
  });
} // 导出物料明细数据

export function ExportPartDetailData(params) {
  return service({
    url: 'DnbarcodeHandmade/ExportPartDetailData',
    method: 'get',
    params: params
  });
}